import React, { useState, useEffect } from 'react';
import { api } from '../../api/client';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import AdminLoading from './AdminLoading';
import AdminEmptyState from './AdminEmptyState';
import { IoShirtSharp } from 'react-icons/io5';

export default function AdminRentalLaundry() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = () => {
    api('/api/admin/rental/laundry')
      .then((data) => { setList(data); setError(''); })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => load(), []);

  const handleMarkDone = async (orderItemId) => {
    setError('');
    try {
      await api(`/api/admin/rental/laundry/${orderItemId}`, { method: 'POST' });
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <AdminLoading />;

  return (
    <Card>
      <CardHeader title="Laundry" subheader="Items in laundry" />
      <CardContent>
        {error && <Typography color="error" className="admin-error" sx={{ mb: 2 }}>{error}</Typography>}
        {list.length === 0 ? (
          <AdminEmptyState message="No items in laundry." icon={IoShirtSharp} />
        ) : (
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Product</TableCell>
                  <TableCell>Order</TableCell>
                  <TableCell>Return by</TableCell>
                  <TableCell>Inward at</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((r) => (
                  <TableRow key={r.order_item_id} hover>
                    <TableCell>{r.product_name} × {r.quantity}</TableCell>
                    <TableCell>#{r.order_id}</TableCell>
                    <TableCell>{r.return_by}</TableCell>
                    <TableCell>{r.inward_at || '–'}</TableCell>
                    <TableCell align="right">
                      <Button size="small" variant="contained" onClick={() => handleMarkDone(r.order_item_id)}>
                        Mark done
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </CardContent>
    </Card>
  );
}
